import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { OldStudentSigphUploadPopupComponent } from '../old-student-sigph-upload-popup/old-student-sigph-upload-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';
import { ConvocationPopupComponent } from '../convocation-popup/convocation-popup.component';

@Component({
  selector: 'app-convocation',
  templateUrl: './convocation.component.html',
  styleUrls: ['./convocation.component.scss']
})
export class ConvocationComponent implements OnInit {

  studentDataForm: FormGroup;
  CourseList: any;
  filteredListCourse: any;
  studentDataList: any[] = [];
  isClgLogin: boolean = sessionStorage.getItem('TLoginName') !== 'admin';
  // selectedOption: string = 'convocation';
  // flagToSend: string = 'T';

  constructor(private dialog: MatDialog, private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    public umsService: UmsService, private spinner: NgxSpinnerService) { }

  userPermission: any;
  UserCollege: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.studentDataForm = this.fb.group({
      CoCode: new FormControl(''),
    })
    this.getstudentdata();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;

    // Get the search value from the input field
    const searchInput = document.querySelector('input[matInput]') as HTMLInputElement;
    const searchValue = searchInput ? searchInput.value : '';
    this.getstudentdata()

    // if (this.selectedOption === 'transcript') {
    //   this.filterTranscriptStudents(searchValue);
    // } else if (this.selectedOption === 'convocation') {
    //   this.filterConvocationStudents(searchValue);
    // } else {
    //   this.getstudentdata(searchValue);
    // }
  }
  updatePhotoSign(student: any, value: string) {
    const dialogRef = this.dialog.open(ConvocationPopupComponent, {
      width: '100%',
      data: {
        selected: student,
        key: value,
        // flag: this.flagToSend ,
        // source: this.selectedOption || 'all'
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.status === 'updated') {
        this.reloadCurrentList();
      }
    });
  }
  reloadCurrentList() {
    const searchInput = document.querySelector('input[matInput]') as HTMLInputElement;
    const searchValue = searchInput ? searchInput.value : '';
    this.getstudentdata(searchValue);
    // if (this.selectedOption === 'transcript') {
    //   this.filterTranscriptStudents(searchValue);
    // }
    // else if (this.selectedOption === 'convocation') {
    //   this.filterConvocationStudents(searchValue);
    // }
    // else {
    //   this.getstudentdata(searchValue);
    // }
  }

  searchStudent(keyword: string): void {
    const searchValue = keyword.trim();

    if (!searchValue) {
      // if (this.selectedOption === 'transcript') {
      //   this.filterTranscriptStudents();
      // } else if (this.selectedOption === 'convocation') {
      //   this.filterConvocationStudents();
      // } else {
      //   this.getstudentdata();
      // }
      this.getstudentdata();
      return;
    }
    this.currentPage = 1;
    // if (this.selectedOption === 'transcript') {
    //   this.filterTranscriptStudents(searchValue);
    // } else if (this.selectedOption === 'convocation') {
    //   this.filterConvocationStudents(searchValue);
    // } else {
    this.getstudentdata(searchValue);
    // }
  }
  onOptionChange(event: any) {
    this.currentPage = 1;
    this.getstudentdata();
    // if (this.selectedOption === 'transcript') {
    //   this.flagToSend = 'T';
    //   this.filterTranscriptStudents();
    // } else if (this.selectedOption === 'convocation') {
    //   this.flagToSend = 'C';
    //   this.filterConvocationStudents();
    // } else {
    //   this.flagToSend = 'T'; 
    //   this.getstudentdata();
    // }
  }

  getstudentdata(searchKeyword?: string) {
    if (this.userPermission[0].CgUi === 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    } else {
      this.UserCollege = '';
    }

    this.spinner.show();

    const payload = {
      PageSize: this.pageSize,
      PageNumber: this.currentPage,
      CgCode: this.isClgLogin ? sessionStorage.getItem('TLoginName') : '',
      // CgCode: this.UserCollege,
      // CoCode: this.studentDataForm.value.CoCode ? this.studentDataForm.value.CoCode : '',
      // StuId: 0,
      RgNo: searchKeyword ? searchKeyword.trim() : '',
      // Flag: '' 
    };

    console.log('Sending payload:', payload);

    this.umsService.convocationData(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status && res.data) {
        res.data.forEach((student: any, index: number) => {

        });
      }

      if (res.status) {
        this.studentDataList = [...res.data];
        this.totalItems = res.data[0]?.TotalRecords || res.data.length;
      } else {
        this.studentDataList = [];
        this.totalItems = 0;
      }
    });
  }
  filterTranscriptStudents(searchKeyword?: string) {
    if (this.userPermission[0].CgUi === 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    } else {
      this.UserCollege = '';
    }

    this.spinner.show();
    const payload = {
      PageSize: this.pageSize,
      PageNumber: this.currentPage,
      CgCode: this.isClgLogin ? sessionStorage.getItem('TLoginName') : '',
      // CgCode: this.UserCollege,
      // CoCode: this.studentDataForm.value.CoCode ? this.studentDataForm.value.CoCode : '',
      // StuId: 0,
      RgNo: searchKeyword ? searchKeyword.trim() : '',
      // Flag: ''
    };

    this.umsService.convocationData(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.studentDataList = [...res.data];
        this.totalItems = res.data[0]?.TotalRecords || res.data.length;
        console.log('Transcript students found:', this.studentDataList.length);
      } else {
        this.studentDataList = [];
        this.totalItems = 0;
      }
    });
  }

  filterConvocationStudents(searchKeyword?: string) {
    if (this.userPermission[0].CgUi === 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    } else {
      this.UserCollege = '';
    }

    this.spinner.show();
    const payload = {
      PageSize: this.pageSize,
      PageNumber: this.currentPage,
      CgCode: this.isClgLogin ? sessionStorage.getItem('TLoginName') : '',
      // CgCode: this.UserCollege,
      // CoCode: this.studentDataForm.value.CoCode ? this.studentDataForm.value.CoCode : '',
      // StuId: 0,
      RgNo: searchKeyword ? searchKeyword.trim() : '',
      // Flag: ''
    };

    this.umsService.convocationData(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.studentDataList = [...res.data];
        this.totalItems = res.data[0]?.TotalRecords || res.data.length;
      } else {
        this.studentDataList = [];
        this.totalItems = 0;
      }
    });
  }

}